/* eslint-disable prettier/prettier */

import pointdeliverymapCss from '/scripts/_partials/shipping/extend/pointdelivery/pointdeliverymap.css?resource';
;
(function (ng) {
  'use strict';

  var CartMapModalCtrl = function ($document, $http, $scope, modalService, $timeout, $element, urlHelper, $q, $interval) {
    var ctrl = this,
      defer = null;
    //ctrl.selectedPoint = false;
    ctrl.loadAddress = false;
    ctrl.loadProcessAddres = false;
    ctrl.loadSearchAddress = false;
    ctrl.loadProcessSearchAddres = false;
    ctrl.checkWriteAddress = $interval(() => {
      if (ctrl.loadAddress && !ctrl.loadProcessAddres) {
        ctrl.loadProcessAddres = true;
        var myGeocoder = ymaps.geocode(ctrl.searchAddres, {
          kind: 'street'
        });
        console.log(myGeocoder);
        try {
          myGeocoder.then(function (res) {
            ctrl.geoLists = res.geoObjects.toArray().map(geo => {
              var data = geo.properties.get('metaDataProperty');
              if (data.GeocoderMetaData.Address.country_code != "RU") return null;
              return data.GeocoderMetaData.Address;
            }).filter(addres => addres != null);
            ctrl.loadAddress = false;
            ctrl.loadProcessAddres = false;
          }, data => {
            ctrl.loadAddress = true;
            ctrl.loadProcessAddres = false;
          });
        } catch (ex) {
          console.log(ex);
        }
      }
    }, 100);
    ctrl.checkCurrentWriteAddress = $interval(() => {
      if (ctrl.loadSearchAddress && !ctrl.loadProcessSearchAddres) {
        ctrl.loadProcessSearchAddres = true;
        console.log(ctrl);
        ctrl.timeLoadItem = $timeout(() => {
          if (ctrl.pointDeliveryMapShipping.PointParams.LazyPointsParams == null) {
            ctrl.setDestination(true);
          } else {
            ctrl.loadPoints();
          }
          console.log(ctrl);
          ctrl.loadProcessSearchAddres = false;
          ctrl.loadSearchAddress = false;
        }, 0);
        console.log(ctrl);
      }
    }, 100);
    ctrl.$onInit = function () {
      $element.on('$destroy', function () {
        modalService.destroy(ctrl.modalId);
        if (ctrl.map) {
          ctrl.map.destroy();
          ctrl.map = null;
        }
      });
    };
    ctrl.init = function () {
      ;
      ctrl.containerMapId = "yaMapPointDelivery" + "_custom"; //+ ctrl.pointDeliveryMapShipping.Id 

      ctrl.loadYandexMap({
        apikey: ctrl.pointDeliveryMapShipping.MapParams.YandexMapsApikey,
        lang: ctrl.pointDeliveryMapShipping.MapParams.Lang
      });
      if (!window.pointDeliveryMapLoaded) {
        window.pointDeliveryMapLoaded = true;
        $(document.body).append($('<link rel="stylesheet" type="text/css" />').attr('href', pointdeliverymapCss));
      }
      // ctrl.initModal();
    };

    ctrl.isLoadedYandexMap = function () {
      return window.yandexMapLoaded || window.ymaps || document.querySelector('script[src*="api-maps.yandex.ru"]') != null;
    };
    ctrl.loadYandexMap = function (params) {
      if (!defer) {
        defer = $q.defer();
      }
      if (window.yandexMapLoaded) {
        // загрузка api карт уже вызвана
        // defer.resolve() будет вызван по загрузке скрипта
      } else if (window.ymaps) {
        // api карт уже прогружен
        defer.resolve();
      } else {
        if (document.querySelector('script[src*="api-maps.yandex.ru"]') != null) {
          // уже кем-то запущена загрузка api карт
          ctrl.waitingInitYmaps();
        } else {
          // сразу устанавливаем флаг, чтобы больше небыло попыток загрузить
          window.yandexMapLoaded = true;
          var script = document.createElement('script');
          script.onload = function () {
            ctrl.waitingInitYmaps();
          };
          script.src = 'https://api-maps.yandex.ru/2.1/?' + urlHelper.paramsToString(angular.extend({
            lang: 'ru-RU'
          }, params || {}));
          document.body.appendChild(script);
        }
      }
      return defer.promise;
    };
    ctrl.waitingInitYmaps = function () {
      // дожидаемся инициализации ymaps
      var delay = 50;
      var maxCount = 3000 / delay; // ждем максимум 3сек
      var countTimer = 0;
      setTimeout(function tick() {
        if (window.ymaps) {
          defer.resolve();
          return;
        }
        countTimer++;
        if (countTimer < maxCount) {
          setTimeout(tick, delay);
        }
      }, delay);
    };
    ctrl.initModal = function () {
      ctrl.fireTemplateReady($scope);
      modalService.renderModal(ctrl.modalId, null, '<div id="' + ctrl.containerMapId + '" class="shipping-point-delivery-map"></div>', null, {
        modalClass: 'shipping-point-delivery-map__modal',
        callbackInit: 'pointDeliveryMapModal.InitModal()',
        callbackOpen: 'pointDeliveryMapModal.OpenModal()',
        callbackClose: 'pointDeliveryMapModal.CloseModal()'
      }, {
        pointDeliveryMapModal: {
          InitModal: function () {},
          OpenModal: function () {
            $timeout(function () {
              if (!ctrl.map) {
                ctrl.map = new ymaps.Map(ctrl.containerMapId, {
                  center: [55.76, 37.64],
                  // Москва
                  zoom: 10,
                  controls: ['zoomControl'],
                  options: {
                    autoFitToViewport: 'always'
                  }
                });
                ctrl.objectManager = new ymaps.ObjectManager({
                  // Чтобы метки начали кластеризоваться, выставляем опцию.
                  clusterize: true,
                  // ObjectManager принимает те же опции, что и кластеризатор.
                  gridSize: 64
                });
                ctrl.map.geoObjects.add(ctrl.objectManager);
                ctrl.setDestination();
                if (ctrl.pointDeliveryMapShipping.PointParams.PointsByDestination === false) {
                  var promise = null;
                  if (ctrl.pointDeliveryMapShipping.PointParams.IsLazyPoints) {
                    promise = ctrl.loadPoints();
                  } else {
                    ctrl.objectManager.add(ctrl.pointDeliveryMapShipping.PointParams.Points);
                    promise = $q.resolve();
                  }
                  promise.then(function () {
                    if (ctrl.pointDeliveryMapShipping.YaSelectedPoint) {
                      ctrl.objectManager.objects.setObjectOptions(ctrl.pointDeliveryMapShipping.YaSelectedPoint, {
                        preset: 'islands#redDotIcon'
                      });
                    }
                  });
                }
                if (ctrl.pointDeliveryMapIsAdmin) {
                  ctrl.map.controls.add(new ymaps.control.SearchControl());
                }
              } else {
                ctrl.setDestination();
                $timeout(function () {
                  ctrl.map.container.fitToViewport();
                }, 300);
              }
              window.PointDeliveryMap = ctrl.MapSelectedPoint;
            });
          },
          CloseModal: function () {
            //ctrl.map.destroy();
            //ctrl.map = null;
            window.PointDeliveryMap = null;
          }
        }
      });
    };
    ctrl.loadPoints = function () {
      var url = urlHelper.getAbsUrl('/checkout/GetShippingData', true);
      return $http.post(url, {
        methodId: ctrl.pointDeliveryMapShipping.MethodId,
        data: ctrl.pointDeliveryMapShipping.PointParams.LazyPointsParams
      }).then(function (response) {
        ctrl.objectManager.removeAll();
        if (response.data) {
          if (ctrl.searchPoint !== undefined && ctrl.searchPoint.length > 0) {
            response.data.features = response.data.features.filter(f => f.properties.balloonContentHeader.toLowerCase().indexOf(ctrl.searchPoint.toLowerCase()) != -1);
          }
          ctrl.dataPoints = response.data;
          ctrl.objectManager.add(response.data);
        }
      });
    };
    ctrl.setDestination = function () {
      let isReload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (ctrl.pointDeliveryMapShipping.MapParams.Destination && ctrl.prevDestination !== ctrl.pointDeliveryMapShipping.MapParams.Destination || isReload) {
        ctrl.prevDestination = ctrl.pointDeliveryMapShipping.MapParams.Destination;
        //центрируем карту по месту доставки
        ymaps.geocode(ctrl.pointDeliveryMapShipping.MapParams.Destination, {
          // Если нужен только один результат, экономим трафик пользователей.
          results: 1
        }).then(function (res) {
          if (res.geoObjects.getLength()) {
            //ctrl.map.options.set({ restrictMapArea: false });
            // Выбираем первый результат геокодирования.
            var firstGeoObject = res.geoObjects.get(0),
              // Область видимости геообъекта.
              bounds = firstGeoObject.properties.get('boundedBy');
            console.log(res);
            if (res.geoObjects.properties != null && res.geoObjects.properties._data != null && res.geoObjects.properties._data.metaDataProperty != null && res.geoObjects.properties._data.metaDataProperty.GeocoderResponseMetaData != null && res.geoObjects.properties._data.metaDataProperty.GeocoderResponseMetaData.Point != null && res.geoObjects.properties._data.metaDataProperty.GeocoderResponseMetaData.Point.coordinates != null) {
              var coordinateStart = res.geoObjects.properties._data.metaDataProperty.GeocoderResponseMetaData.Point.coordinates;
              ctrl.map.setCenter([coordinateStart[1], coordinateStart[0]], 10);
            } else {
              // Масштабируем карту на область видимости геообъекта.
              ctrl.map.setBounds(bounds, {
                // Проверяем наличие тайлов на данном масштабе.
                checkZoomRange: true
              }).then(function () {
                //ctrl.map.options.set({ restrictMapArea: true/*bounds*/ });
              });
            }
            if (ctrl.pointDeliveryMapShipping.PointParams.PointsByDestination) {
              var promise = null;
              if (ctrl.pointDeliveryMapShipping.PointParams.IsLazyPoints) {
                promise = ctrl.loadPoints();
              } else {
                ctrl.objectManager.removeAll();

                //if (ctrl.pointDeliveryMapShipping.PointParams.Points.features != null && ctrl.pointDeliveryMapShipping.PointParams.Points.features.length > 0) {
                //    ctrl.pointDeliveryMapShipping.PointParams.Points.features = ctrl.pointDeliveryMapShipping.PointParams.Points.features.map((item) => {
                //        item.properties.balloonContentBody = "";
                //        item.properties.balloonContentFooter = "";
                //        item.properties.balloonContentHeader = null;
                //        return item;
                //    })
                //}

                console.log('543543');
                console.log(ctrl);
                let points = {
                  features: ctrl.pointDeliveryMapShipping.PointParams.Points.features,
                  type: ctrl.pointDeliveryMapShipping.PointParams.Points.type
                };
                ctrl.pointDeliveryMapShipping.PointParams.Points;
                if (ctrl.searchPoint !== undefined && ctrl.searchPoint.length > 0) {
                  points.features = points.features.filter(f => f.properties.balloonContentHeader.toLowerCase().indexOf(ctrl.searchPoint.toLowerCase()) != -1);
                }
                ctrl.objectManager.add(points);
                promise = $q.resolve();
                ctrl.dataPoints = points;
              }
              promise.then(function () {
                if (ctrl.pointDeliveryMapShipping.YaSelectedPoint) {
                  ctrl.objectManager.objects.setObjectOptions(ctrl.pointDeliveryMapShipping.YaSelectedPoint, {
                    preset: 'islands#redDotIcon'
                  });
                }
              });
            }
          }
        });
      }
    };

    ///Метод при выборе точки
    ctrl.MapSelectedPoint = function (yaPointId, pointId) {
      if (ctrl.pointDeliveryMapShipping.YaSelectedPoint) {
        ctrl.objectManager.objects.setObjectOptions(ctrl.pointDeliveryMapShipping.YaSelectedPoint, {
          preset: 'islands#dotIcon'
        });
      }
      ctrl.objectManager.objects.setObjectOptions(yaPointId, {
        preset: 'islands#redDotIcon'
      });
      ctrl.pointDeliveryMapShipping.YaSelectedPoint = yaPointId;
      ctrl.pointDeliveryMapShipping.PickpointId = pointId;
      ctrl.pointDeliveryMapCallback({
        event: 'pointDeliveryMap',
        field: ctrl.pointDeliveryMapShipping.PickpointId || 0,
        shipping: ctrl.pointDeliveryMapShipping
      });
      if (ctrl.map) {
        ctrl.map.destroy();
        ctrl.map = null;
        ctrl.objectManager = null;
      }
      modalService.close("modalMap");
      modalService.destroy("modalMap");
      ctrl.prevDestination = "";
      ctrl.selectedPoint = true;
    };
    ctrl.openModal = () => {
      ctrl.pointDeliveryIsSelectedPoint = false;
      var options = {
        'modalClass': 'map-delivery',
        'isOpen': true,
        'destroyOnClose': true,
        'isShowFooter': false
      };
      modalService.renderModal('modalMap', null, '<div class="yndex-map-delivery" data-ng-include="\'/Templates/Promo/scripts/_partials/cart/modals/mapDelivery.html\'"></div>', null, options, {
        modalMap: ctrl
      });
    };
    ctrl.customInitMap = () => {
      if (!ctrl.map) {
        ctrl.map = new ymaps.Map(ctrl.containerMapId, {
          center: [55.76, 37.64],
          // Москва
          zoom: 10,
          controls: ['zoomControl'],
          options: {
            autoFitToViewport: 'always'
          }
        });
        ctrl.objectManager = new ymaps.ObjectManager({
          // Чтобы метки начали кластеризоваться, выставляем опцию.
          clusterize: true,
          // ObjectManager принимает те же опции, что и кластеризатор.
          gridSize: 64
        });
        ctrl.map.geoObjects.events.add(['balloonopen', 'balloonclose' /*, 'click'*/], function (e) {
          var target = e.get('target');
          if (target._objectIdWithOpenBalloon != undefined && target._objectIdWithOpenBalloon != null) {
            $timeout(function () {
              ctrl.dataSelectedPoint = ctrl.dataPoints.features.filter(p => p.id == target._objectIdWithOpenBalloon)[0];
            }, 300);
          }
        });
        ctrl.map.geoObjects.add(ctrl.objectManager);
        ctrl.setDestination();
        if (ctrl.pointDeliveryMapIsAdmin) {
          ctrl.map.controls.add(new ymaps.control.SearchControl());
        }
      } else {
        ctrl.setDestination();
        $timeout(function () {
          ctrl.map.container.fitToViewport();
        }, 300);
      }
      window.PointDeliveryMap = ctrl.MapSelectedPoint;
      $timeout(function () {
        ctrl.map.container.fitToViewport();
        //ctrl.map.setCenter(16);
      }, 500);
    };
    ctrl.closeBoolynAll = () => {
      ctrl.map.balloon.close();
    };
    ctrl.fireTemplateReady = (scope, value) => {
      scope.$emit(eventReady, value);
    };
    ctrl.searchListAddress = () => {
      if (ctrl.timeLoad != null) $timeout.cancel(ctrl.timeLoad);
      ctrl.timeLoad = $timeout(() => {
        ctrl.loadAddress = true;
      }, 500);
    };
    ctrl.searchPointForInput = () => {
      if (ctrl.pointTimeLoad != null) $timeout.cancel(ctrl.pointTimeLoad);
      ctrl.pointTimeLoad = $timeout(() => {
        ctrl.loadSearchAddress = true;
      }, 500);
    };
    ctrl.changeAddress = geo => {
      //установка адреса при выборе его из списка
      ctrl.searchAddres = geo.formatted;
      ctrl.geoLists = [];
      let address = {
        City: ctrl.geoFilter(geo.Components, 'locality', 'province'),
        Street: ctrl.geoFilter(geo.Components, 'street'),
        House: ctrl.geoFilter(geo.Components, 'house'),
        Country: ctrl.geoFilter(geo.Components, 'country')
      };
      let checkoutService = ctrl.pointDeliveryCheckoutCart.cartCheckoutService;
      ctrl.pointDeliveryCheckoutCart.cartCheckoutService.processContact(address).then(data => {
        checkoutService.saveContact(data.obj).then(() => {
          checkoutService.getShipping().then(shippings => {
            ctrl.pointDeliveryMapShipping.PointParams = shippings.selectShipping.PointParams;
            ctrl.pointDeliveryMapShipping.MapParams = shippings.selectShipping.MapParams;
            ctrl.pointDeliveryMapShipping.CityTo = shippings.selectShipping.CityTo;
            if (ctrl.pointDeliveryMapShipping.PointParams.IsLazyPoints) {
              ctrl.loadPoints();
            } else {
              ctrl.objectManager.removeAll();
              if (ctrl.pointDeliveryMapShipping.PointParams.Points) {
                ctrl.dataPoints = ctrl.pointDeliveryMapShipping.PointParams.Points;
                console.log(1133);
                if (ctrl.searchPoint !== undefined && ctrl.searchPoint.length > 0) {
                  ctrl.pointDeliveryMapShipping.PointParams.Points = ctrl.pointDeliveryMapShipping.PointParams.Points.filter(f => f.properties.balloonContentHeader.indexOf(ctrl.searchPoint) != -1);
                }
                ctrl.objectManager.add(ctrl.pointDeliveryMapShipping.PointParams.Points);
              }
            }
            ctrl.setDestination();
          });
        });
      });
    };
    ctrl.closeModal = () => {
      if (ctrl.map) {
        ctrl.map.destroy();
        ctrl.map = null;
        ctrl.objectManager = null;
      }
      modalService.close("modalMap");
      modalService.destroy("modalMap");
      ctrl.prevDestination = "";
    };
    ctrl.geoFilter = function (arrayGeo, kindType, additionalkindType) {
      let isLastItem = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      let searchItems = arrayGeo.filter(item => item.kind == kindType);
      if (searchItems != null && searchItems.length > 0) {
        if (isLastItem) {
          return searchItems[searchItems.length - 1].name;
        }
        return searchItems[0].name;
      } else if (additionalkindType != null && additionalkindType.length > 0) {
        searchItems = arrayGeo.filter(item => item.kind == additionalkindType);
        if (searchItems != null && searchItems.length > 0) {
          return searchItems[searchItems.length - 1].name;
        }
      }
      return '';
    };
    ctrl.setCurrentLocationOnMap = () => {
      var location = ymaps.geolocation.get();
      // Асинхронная обработка ответа.
      location.then(function (result) {
        ymaps.geocode(result.geoObjects.position).then(function (res) {
          ctrl.map.setCenter(result.geoObjects.position, 16);
          var propertyGeo = res.geoObjects.get(0).properties.get('metaDataProperty');
          ctrl.changeAddress(propertyGeo.GeocoderMetaData.Address);
        });
        ctrl.map.geoObjects.add(result.geoObjects);
      }, function (err) {
        console.log('Ошибка: ' + err);
      });
    };
  };
  angular.module('cart').controller('CartMapModalCtrl', CartMapModalCtrl);
  CartMapModalCtrl.$inject = ['$document', '$http', '$scope', 'modalService', '$timeout', '$element', 'urlHelper', '$q', '$interval'];
})(angular);